import getBlockIdByElement from '../../blocks/accessors/get-block-id-by-element';
import getBlockSettings from '../../blocks/accessors/get-block-settings';
import areChildrenEnabledForNode from './are-children-enabled-for-node';

const areAllChildrenHidden = (liveElement) => {
  const blockId = getBlockIdByElement(liveElement);
  const blockSettings = getBlockSettings(blockId);

  if (!blockSettings || !blockSettings.optionalChildren) {
    return null;
  }

  const { optionalChildren } = blockSettings;

  return optionalChildren.every(
    (item) => !areChildrenEnabledForNode(liveElement, item.querySelector)
  );
};

export default areAllChildrenHidden;
